import React from "react";

export default function FounderQuoteSection({ data }) {
  return (
    <section className="founder-quote">
      <div className="container founder-quote-inner">
        <div className="founder-quote-copy">
          <span className="founder-quote-icon" aria-hidden="true">
            <i className="fa-solid fa-quote-left" />
          </span>
          <blockquote>“{data.text}”</blockquote>
          <p className="founder-quote-name">{data.name}</p>
          <p className="founder-quote-role">{data.role}</p>
        </div>
        <div className="founder-quote-portrait">
          <span className="founder-quote-accent" />
          <img src={data.image} alt={data.imageAlt} />
        </div>
      </div>
    </section>
  );
}
